
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/docs/komodo-defi-framework/api/legacy/send_raw_transaction",
      function () {
        return require("private-next-pages/en/docs/komodo-defi-framework/api/legacy/send_raw_transaction/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/docs/komodo-defi-framework/api/legacy/send_raw_transaction"])
      });
    }
  